import type { StoredCommercialRequest } from "../types";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SectionPaper } from "@/components/Paper";
import { FeedGrid } from "./CommercialBookListFeedGrid";
import { StoredListLoadError } from "./StoredListLoadError";

interface Props {
  /** 取得依頼の検索結果。undefined は初回の読み込み前 */
  results?: StoredCommercialRequest[];
  loading: boolean;
  /** 一覧の読み込みに失敗したか。結果が無いときだけ失敗を表示する */
  loadFailed: boolean;
  /** 共有ONの会社か */
  isSharable: boolean;
}

export const CommercialPictureRequestPanel: React.FC<Props> = ({
  results,
  loading,
  loadFailed,
  isSharable,
}) => {
  const grid =
    results === undefined && loadFailed && !loading ? (
      <StoredListLoadError />
    ) : (
      <FeedGrid
        rows={results ?? []}
        loading={loading || results === undefined}
        isSharable={isSharable}
      />
    );
  const theme = useTheme();
  // SP（md未満）はカード表示。外側を白カードで囲むと個々のカードと二重に見えるため、
  // 背景なしのプレーンな領域にして、カードだけがページ背景に並ぶようにする
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return (
      <Box>
        {grid}
        <Box sx={{ mb: 6 }} />
      </Box>
    );
  }

  return (
    <SectionPaper>
      {grid}
      <Box sx={{ mb: 6 }} />
    </SectionPaper>
  );
};
